





























	import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";

	@Component
	export default class BaseTLCheckBoxDesign extends Vue {
		@Prop({ type: String, required: false, default: "" }) label?: string; //hlavní popis
		@Prop({ type: String, required: false, default: "black" }) design?: string; //design basic, white   
		@Prop({ type: String, required: false, default: "" }) id?: string; //id
		@Prop({ type: Boolean, required: false, default: false }) selected!: boolean; //checked vybrano
        @Prop({ type: Boolean, required: false, default: false }) halfSelect?: boolean; //mezi stav
		@Prop({ type: Boolean, required: false, default: true }) nextLine?: boolean; //odradkovani
		@Prop({ type: Boolean, required: false, default: false }) readonly?: boolean; //needitovalné checkbox
		@Prop({ type: Boolean, required: false, default: false }) labelTop!: boolean; //popisek nahore
		//pro vice checkboxove pole
		@Prop({ type: Boolean, required: false, default: true }) onlyOne?: boolean; //pouze jeden prvek
		@Prop({ required: false }) items: any; //vice prvkový seznam
		@Prop({ required: false }) helpId: any; //ukladani pomocnych hodnot - id
		@Prop({ required: false }) helpIndex: any; //ukladani pomocnych hodnot - index
		@Prop({ required: false }) helpKey: any; //ukladani pomocnych hodnot - key

		@Prop({ type: Boolean, required: false, default: false }) activeLabel!: boolean; //přepinani checkboxu pomoci labelu	
		@Prop({ type: String, required: false, default: null }) tooltip?: string; //tooltip

		created() {
		}

		private isSelected() {
            return this.selected && !this.halfSelect;
		}

        private isSelectedInter() {
            return this.halfSelect == true;
        }
		private isSelectedList(item: any) {
			return item.selected == true && this.halfSelect == false;
		}

		private isSelectedListInter(item: any) {
            return this.halfSelect == true;
        }

		private clickLabel() {
			this.$emit('clickLabel', this.id);

		}

		private change() {
			if (!this.readonly) {
				this.changeCheckBoxTable();
				this.$emit('change', this.id);
			}
		}

		//check box v editacni tabulce
		private changeCheckBoxTable() {
			if (!this.readonly) {
				this.$emit('changeTable',this.id, this.helpId, this.helpKey);
			}
		}

		private changeList(item: any) {
			if (!this.readonly) {           
				this.$emit('changeList', item.key, this.helpId, this.helpKey);
			}
		}

		get inputClassLabelActive() {
			return {
                "checkBoxDesignLabel": this.design == "black" && this.activeLabel,
                "checkBoxDesignLabelWhite": this.design == "white" && this.activeLabel,
			}
		}

        get inputClassLabel() {
            return {
                "checkBoxLabelText": this.design == "black" ,
                "checkBoxLabelTextWhite": this.design == "white" 
            }
        }

		get inputClass() {
			return {
                "checkbox-border ": this.design == "black",
                "checkbox-border-white ": this.design == "white",
				"checBoxReadOnly": this.readonly,
				"checkBoxInputBase": this.design == 'basic',
			};
		}

		get inputClassBase() {
			return {
				"checkbox-button": this.readonly==true? false: true,				
				"helpCenterBlock": this.labelTop
			};
		}

        get inputClassCenter() {
            return {
                "checkbox-center": this.design == "black",
                "checkbox-center-white": this.design == "white"
            };
        }


	}
